import {Badge} from "@mantine/core";
import {SetupIntentStatus} from "../types";

export const StatusBadge = ({status}: { status: string }) => {

    const colors = {
        [SetupIntentStatus.canceled]: '#6c757d',
        [SetupIntentStatus.processing]: '#007bff',
        [SetupIntentStatus.requiresAction]: '#28a745',
        [SetupIntentStatus.requiresConfirmation]: '#ffc107',
        [SetupIntentStatus.requiresPaymentMethod]: '#17a2b8',
        [SetupIntentStatus.succeeded]: '#28a748'
    } as { [key: string]: string }


    return <Badge color={colors[status]}>{status}</Badge>;

};
